<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
    <div class="grid-row">
        <div class="column-two-thirds">
            <h1 class="heading-xlarge">Page Not Found</h1>
            <div id="who-we-are">
                <p>
                  The requested page could not be found.
                </p>
                <p>
                  Please check and try again, or go to the <a href="/" class="govuk-link">MTC Homepage</a>
                </p>
            </div>
        </div>
        <div class="column-one-third add-title-margin">
            <br/>
            <aside role="complementary" class="support-column">
                <h3 class="heading-medium">Related</h3>
                <nav role="navigation">
                    <ul class="list">
                        <li>
                            <a class="govuk-link" href="/">MTC Homepage</a>
                        </li>
                    </ul>
                </nav>
            </aside>
        </div>
    </div>
</main>
<app-footer></app-footer>
